import { useTranslation } from 'react-i18next';

import { WarningMessage } from '@hotjar/webapp/components/Message';

import { MessageKind } from './limitations-message-type';

interface Props {
  kind: MessageKind;
}

export const LimitationsMessage = ({ kind }: Props): JSX.Element | null => {
  const { t } = useTranslation();

  switch (kind) {
    case MessageKind.RESTRICTED_WARNING: {
      return (
        <WarningMessage>
          {t('common:recordings.segment-edit-create.forward-to-slack.restricted-filters-warning', {
            filter1: 'Favorited',
            filter2: 'Team comments',
          })}
        </WarningMessage>
      );
    }
    default: {
      return null;
    }
  }
};
